import React from 'react';

const BrandLogo = ({ compact = false, className = '' }) => (
  <span className={`inline-flex shrink-0 items-center gap-2.5 ${className}`} translate="no">
    <img src={`${process.env.PUBLIC_URL}/sagemindlabs-mark.svg`} width="40" height="40" alt="" className="h-10 w-10 shrink-0" />
    {compact ? <span className="sr-only">SageMindLabs</span> : (
      <span className="text-lg font-semibold tracking-tight text-white">SageMind<span className="font-normal text-gray-400">Labs</span></span>
    )}
  </span>
);

export default BrandLogo;
